import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class QrScanService {


    constructor(
    ) {
    }


    public decodeDeviceInfoFromQR(datastream) {
        let mac;
        let type;

        // example IOT:I:<mac>;T:<GLOW|GLOW-TH>;
        if (datastream  && String(datastream).length>3 && String(datastream).substring(0, 3) === "IOT") {
            mac = String(datastream).substring(6, 18);
// example GDZ30C6F757D720ZGB102020024;
        } else if (datastream  && String(datastream).length>3 && String(datastream).substring(0, 3) === "GDZ") {
            mac = String(datastream).substring(3, 15);
        }

        return { mac, type }



    }

}
